import {Component, forwardRef, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IconComponent} from "../icon/icon.component";

import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from "@angular/forms";

@Component({
    selector: 'app-input',
    imports: [
    IconComponent,
    ReactiveFormsModule,
    FormsModule
],
    templateUrl: './input.component.html',
    styleUrl: './input.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => InputComponent),
        }
    ]
})
export class InputComponent implements OnInit, ControlValueAccessor {
  @Input() public type: 'text' | 'password' | 'checkbox' | 'radio' | 'textarea' | 'email' = 'text';
  @Input() public placeholder: string = '';
  @Input() public label: string = '';
  @Input() public control!: FormControl | AbstractControl;
  @Input() public name: string = 'app-input';
  @Input() public value: string = '';
  @Input() public hasError: boolean = false;

  public currentType: string = 'text';
  @Input() messages: Record<string, string> = {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: (value: string) => void = (): void => {
  };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: () => void = (): void => {
  };

  public disabled: boolean = false;

  public ngOnInit(): void {
    this.currentType = this.type;
  }

  public toggleType(): void {
    this.currentType = this.currentType === 'password' ? 'text' : 'password';
  }

  public registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: string): void {
    this.value = obj;
  }

  public handleChange(event: Event): void {
    const value: string = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChange(value);
    this.onTouch();
  }
}
